$(document).ready(function () {
	function close_accordion_section() {
		$('.accordion .accordion-section-title').removeClass('active');
		$('.accordion .accordion-section-content').slideUp(300).removeClass('open');
	}

	$('.accordion-section-title').click(function (e) {
		// Grab current anchor value
		var currentAttrValue = $(this).attr('href');

		if ($(e.target).is('.active')) {
			close_accordion_section();
		} else {
			close_accordion_section();

			// Add active class to section title
			$(this).addClass('active');
			// Open up the hidden content panel
			$('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
		}

		e.preventDefault();
	});

   $('#LanguageList').on('change',function(e) {
     var val = $(this).val();
 
     $(this).closest('form').find('[name="locale_code"]').val(val);
     $(this).closest('form').submit();
     
   });

  // custom traslation
   if($('#LanguageList').length && $(".site-header__lang")){
     var val = $('#LanguageList').val();
     
     if(val == 'en'){
       $(".site-header__lang.lang_en").trigger("click");
     }
     if(val == 'de'){
       $(".site-header__lang.lang_de").trigger("click");
     }
   }
   // custom traslation
  
});